import { render, staticRenderFns } from "./PerformanceButtons.vue?vue&type=template&id=18d7208b&scoped=true"
import script from "./PerformanceButtons.vue?vue&type=script&lang=js"
export * from "./PerformanceButtons.vue?vue&type=script&lang=js"
import style0 from "./PerformanceButtons.vue?vue&type=style&index=0&id=18d7208b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7208b",
  null
  
)

export default component.exports